import { createSelector } from 'reselect';

const selectnpsubscriptions = (state: any) => state.npsubscriptions;


export const selectnpsubscriptionsCurrentItem = createSelector([selectnpsubscriptions], (npsubscriptions) => npsubscriptions.current);

export const selectnpsubscriptionsListItems = createSelector([selectnpsubscriptions], (npsubscriptions) => npsubscriptions.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectnpsubscriptionsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectnpsubscriptionsQueryItems = createSelector([selectnpsubscriptions], (npsubscriptions) => npsubscriptions.query);

export const selectnpsubscriptionsCreatedItem = createSelector([selectnpsubscriptions], (npsubscriptions) => npsubscriptions.create);

export const selectnpsubscriptionsUpdatedItem = createSelector([selectnpsubscriptions], (npsubscriptions) => npsubscriptions.update);

export const selectnpsubscriptionsReadItem = createSelector([selectnpsubscriptions], (npsubscriptions) => npsubscriptions.read);

export const selectnpsubscriptionsDeletedItem = createSelector([selectnpsubscriptions], (npsubscriptions) => npsubscriptions.delete);

export const selectnpsubscriptionsSearchedItems = createSelector([selectnpsubscriptions], (npsubscriptions) => npsubscriptions.search);

export const selectnpsubscriptionsItemsCount = createSelector([selectnpsubscriptions], (npsubscriptions) => npsubscriptions.count);

export const selectnpsubscriptionsItemsFilter = createSelector([selectnpsubscriptions], (npsubscriptions) => npsubscriptions.filter);